// Adds two textures from incoming sampler2DArray

// use like: vec3 col = finalLevels(someTex.rgb, 34.0/255.0, 1.5, 235.0/255.0); from  https ://gist.github.com/aferriss/9be46b6350a08148da02559278daa244 
vec3 gammaCorrect(vec3 color, float gamma) {
    return pow(color, vec3(1.0 / gamma));
}

vec3 levelRange(vec3 color, float minInput, float maxInput) {
    return min(max(color - vec3(minInput), vec3(0.0)) / (vec3(maxInput) - vec3(minInput)), vec3(1.0));
}

vec3 finalLevels(vec3 color, float minInput, float gamma, float maxInput) {
    return gammaCorrect(levelRange(color, minInput, maxInput), gamma);
}

uniform mediump sampler2DArray texArray;
varying vec2 vUv;

void main() {
    vec3 color = texture(texArray, vec3(vUv, 0.)).rgb + texture(texArray, vec3(vUv, 1.)).rgb;
    color = levelRange(color, 0., 1.7);
    gl_FragColor = vec4(color, 1.);
}
